import {Api} from '@wellstone-solutions/common';
import type {AxiosRequestConfig, AxiosResponse} from 'axios';
import type {AxiosAuthRefreshRequestConfig} from 'axios-auth-refresh';

export const apiV2 = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig & AxiosAuthRefreshRequestConfig,
): Promise<AxiosResponse<T>> =>
  Api.Instance.v2().axiosInstance({...config, ...options});
